<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery" class="search-form">
        <!-- <a-row :gutter="[16, 8]">
          <a-col :md="8" :sm="24">
            <a-form-item :label="$t(I18N_KEY.REPAYREPORT + 'datadt')" :labelCol="{ span: 6 }"
              :wrapperCol="{ span: 18 }">
              <a-range-picker v-model="queryParam.dataDt" format="DD-MM-YYYY" style="width: 100%" />
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="12">
            <a-form-item :label="$t(I18N_KEY.REPAYREPORT + 'productType')">
              <a-select default-value="" style="width: 100%" v-model="queryParam.productType">
                <a-select-option value="">{{ $t(I18N_KEY.REPAYREPORT + 'all') }} </a-select-option>
                <a-select-option value="1">{{ $t(I18N_KEY.REPAYREPORT + 'mainProduct') }} </a-select-option>
                <a-select-option value="2">{{ $t(I18N_KEY.REPAYREPORT + 'multiLoanProduct') }} </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="4" :sm="12">
            <a-form-item :label="$t(I18N_KEY.REPAYREPORT + 'installmentType')">
              <a-select default-value="" style="width: 100%" v-model="queryParam.pageType">
                <a-select-option value="">
                  {{ $t(I18N_KEY.REPAYREPORT + 'initial') }}
                </a-select-option>
                <a-select-option value="1">
                  {{ $t(I18N_KEY.REPAYREPORT + 'all') }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24" class="form-buttons">
            <a-button type="primary" @click="searchQuery" icon="search" style="margin-right: 8px">{{
              $t('search')
            }}</a-button>
            <a-button type="primary" @click="downLoadData('')" icon="download">{{ $t('exportFile') }}</a-button>
          </a-col>
        </a-row> -->

        <div style="display: flex">
          <a-form-item
            :label="$t(I18N_KEY.REPAYREPORT + 'datadt')"
            :labelCol="{ span: 6 }"
            style="width: 300px; margin-right: 20px"
          >
            <a-range-picker v-model="queryParam.dataDt" format="DD-MM-YYYY" style="width: 100%" />
          </a-form-item>

          <!-- <a-form-item style="width: 300px; margin-right: 20px;" :label="$t(I18N_KEY.REPAYREPORT + 'productType')">
              <a-select default-value=""  v-model="queryParam.productType">
                <a-select-option value="">{{ $t(I18N_KEY.REPAYREPORT + 'all') }} </a-select-option>
                <a-select-option value="1">{{ $t(I18N_KEY.REPAYREPORT + 'mainProduct') }} </a-select-option>
                <a-select-option value="2">{{ $t(I18N_KEY.REPAYREPORT + 'multiLoanProduct') }} </a-select-option>
              </a-select>
            </a-form-item> -->

          <!-- <a-form-item style="width: 300px; margin-right: 20px;" :label="$t(I18N_KEY.REPAYREPORT + 'installmentType')">
              <a-select default-value="" style="width: 100%" v-model="queryParam.pageType">-model="queryParam.pageType">
                <a-select-option value="">
                  {{ $t(I18N_KEY.REPAYREPORT + 'initial') }}
                </a-select-option>
                <a-select-option value="1">
                  {{ $t(I18N_KEY.REPAYREPORT + 'all') }}
                </a-select-option>
              </a-select>
            </a-form-item> -->

          <div>
            <a-button type="primary" @click="searchQuery" icon="search" style="margin-right: 28px">{{
              $t('search')
            }}</a-button>
            <!-- <a-button type="primary" @click="downLoadData('')" icon="download">{{ $t('exportFile') }}</a-button> -->
          </div>
        </div>
      </a-form>

      <a-table
        ref="table"
        rowKey="id"
        size="middle"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :scroll="{ x: 'max-content' }"
        bordered
        :rowClassName="
          (record) =>
            isWeekDay(record.datadt)
              ? 'table_weekendColor'
              : record.datadt == 'Subtotal'
              ? 'subtotal'
              : isbetweenWeek(record.datadt)
              ? 'betweenWeek'
              : ''
        "
        @change="handleTableChange"
      >
        <template slot="datadt" slot-scope="text">
          {{ text === 'subtotal' ? $t(I18N_KEY.REPAYREPORT + 'subtotal') : formatDatadt(text) }}
        </template>
      </a-table>
    </div>
    <RefundTradeModal ref="modalForm" @ok="modalFormOk"></RefundTradeModal>
  </a-card>
</template>

<script>
import { filterObj } from '@/utils/util'
import { getAppAllCountForDate } from '@/webpublicapi/order'
import Dict from '../modules/Dict'
import { REFUND_TRADE_STATUS } from '@/constants/status'
import RefundTradeModal from './modules/RefundTradeModal'
import moment from 'moment'
import exportFile from '@/webpublicapi/exportFile'
import { transformTime } from '@/components/_util/util'

const I18N_KEY = {
  ORDER: 'order.',
  CUSTOMER: 'customer.',
  APPROVAL: 'approval.',
  REPAYREPORT: 'repayReport.',
}

export default {
  name: 'AppList',
  components: {
    RefundTradeModal,
    Dict,
  },
  data() {
    return {
      I18N_KEY,
      visible: false,
      REFUND_TRADE_STATUS,
      // Pagination params
      ipagination: {
        current: 1,
        pageSize: 10,
        balPageSize: 10,
        pageSizeOptions: ['10'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' ' + this.$t('components.total') + total + this.$t('components.items')
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0,
      },
      headers: {
        // authorization: 'authorization-text',
      },

      dataSource: [],
      // Query conditions
      queryParam: {
        dataDt: [moment().add('days', -60), moment().add('days', 0)],
      },
      loading: false,
      // Dynamic column (fromAPIReturn)
      dynamicColumns: [],
      isorter: {
        column: 'createTime',
        order: 'desc',
      },
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 },
      },
    }
  },
  computed: {
    columnsInit() {
      return [
        {
          title: this.$t(I18N_KEY.REPAYREPORT + 'datadt'),
          align: 'left',
          dataIndex: 'datadt',
          width: 100,
          scopedSlots: { customRender: 'datadt' },
        },
        {
          title: this.$t(I18N_KEY.REPAYREPORT + 'fee'),
          align: 'left',
          dataIndex: 'fee',
          width: 120,
        },
        {
          title: this.$t(I18N_KEY.REPAYREPORT + 'installs'),
          align: 'left',
          dataIndex: 'installs',
          width: 130,
        },
        // {
        //   title: this.$t(I18N_KEY.REPAYREPORT + 'repeatGaid'),
        //   align: 'left',
        //   dataIndex: 'oldInstalls',
        //   width: 140,
        // },
        // {
        //   title: this.$t(I18N_KEY.REPAYREPORT + 'gaidRepeatRate'),
        //   align: 'left',
        //   dataIndex: 'oldGaidRate',
        //   width: 160,
        // },
        // {
        //   title: this.$t(I18N_KEY.REPAYREPORT + 'filteredInstallCount'),
        //   align: 'left',
        //   dataIndex: 'subOldGaidNum',
        //   width: 180,
        // },
        {
          title: this.$t(I18N_KEY.REPAYREPORT + 'regCount'),
          align: 'left',
          dataIndex: 'regCount',
          width: 130,
        },
        {
          title: this.$t(I18N_KEY.REPAYREPORT + 'subCount'),
          align: 'left',
          dataIndex: 'subCount',
          width: 130,
        },
        {
          title: this.$t(I18N_KEY.REPAYREPORT + 'approvalCount'),
          align: 'left',
          dataIndex: 'approvalCount',
          width: 140,
        },
        {
          title: this.$t(I18N_KEY.REPAYREPORT + 'loanCount'),
          align: 'left',
          dataIndex: 'loanCount',
          width: 150,
        },
        {
          title: this.$t(I18N_KEY.REPAYREPORT + 'irRate'),
          align: 'left',
          dataIndex: 'irRate',
          width: 250,
        },
        // {
        //   title: this.$t(I18N_KEY.REPAYREPORT + 'filteredInstallRegRate'),
        //   align: 'left',
        //   dataIndex: 'subOldGaidRate',
        //   width: 200,
        // },
        {
          title: this.$t(I18N_KEY.REPAYREPORT + 'rsRate'),
          align: 'left',
          dataIndex: 'rsRate',
          width: 270,
        },
        {
          title: this.$t(I18N_KEY.REPAYREPORT + 'saRate'),
          align: 'left',
          dataIndex: 'saRate',
          width: 250,
        },
        {
          title: this.$t(I18N_KEY.REPAYREPORT + 'slRate'),
          align: 'left',
          dataIndex: 'slRate',
          width: 270,
        },
        {
          title: this.$t(I18N_KEY.REPAYREPORT + 'alRate'),
          align: 'left',
          dataIndex: 'alRate',
          width: 250,
        },
        {
          title: this.$t(I18N_KEY.REPAYREPORT + 'installFee'),
          align: 'left',
          dataIndex: 'installFee',
          width: 250,
        },
        {
          title: this.$t(I18N_KEY.REPAYREPORT + 'regFee'),
          align: 'left',
          dataIndex: 'regFee',
          width: 250,
        },
        {
          title: this.$t(I18N_KEY.REPAYREPORT + 'subFee'),
          align: 'left',
          dataIndex: 'subFee',
          width: 250,
        },
        {
          title: this.$t(I18N_KEY.REPAYREPORT + 'approvalFee'),
          align: 'left',
          dataIndex: 'approvalFee',
          width: 250,
        },
        {
          title: this.$t(I18N_KEY.REPAYREPORT + 'loanFee'),
          align: 'left',
          dataIndex: 'loanFee',
          width: 250,
        },
      ]
    },
    columns() {
      return [...this.columnsInit, ...this.dynamicColumns]
    },
  },
  created() {
    this.loadData(1)
  },
  methods: {
    isbetweenWeek(dateString) {
      if (dateString.length == 21) {
        console.log(2222222, dateString.length)
        return true
      }
    },
    isWeekDay(day) {
      const date = new Date(day)
      return date.getDay() % 6 === 0 ? 'table_weekendColor' : ''
    },
    searchQuery() {
      this.loadData(1)
    },
    loadData(arg) {
      // Load data If params passed1Then load first page content
      if (arg === 1) {
        this.ipagination.current = 1
      }
      this.loading = true
      var params = this.getQueryParams() // Query conditions
      getAppAllCountForDate(Object.assign({}, params))
        .then((res) => {
          if (res.code === 1000) {
            this.dynamicColumns = res.data.columns || []

            this.dataSource = res.data.rows
            this.ipagination.total = res.data.total
            this.ipagination.pageSize = this.ipagination.balPageSize

            // this.dataSource = res.data.totalList || [];
            //
            //   for(var i = 0 ; i < res.data.rows.length ; i++){
            //     this.dataSource.push(res.data.rows[i]);
            //   }
            // console.log(this.dataSource);
          } else {
            this.ipagination.total = 0
            this.dataSource = []
            this.$message.error(res.msg)
          }
          this.loading = false
        })
        .catch((e) => {
          this.loading = false
          this.$message.error(e.message)
        })
    },
    getQueryParams() {
      const { dataDt } = this.queryParam
      const data = {
        ...this.queryParam,
        startDate: dataDt && this.transformTime(dataDt[0]),
        endDate: dataDt && this.transformTime(dataDt[1]),
      }
      delete data.dataDt
      data.pageNum = this.ipagination.current
      data.pageSize = this.ipagination.balPageSize
      return filterObj(data)
    },
    formatDatadt(text) {
      if (!text) return text

      // Process date range format (2026-06-10 - 2026-06-16)
      if (typeof text === 'string' && text.length === 21 && text.includes('-')) {
        const start = text.slice(0, 10)
        const end = text.slice(11)
        const startM = moment(start, 'YYYY-MM-DD', true)
        const endM = moment(end, 'YYYY-MM-DD', true)
        if (startM.isValid() && endM.isValid()) {
          return `${startM.format('DD-MM-YYYY')} - ${endM.format('DD-MM-YYYY')}`
        }
      }

      // Process single date
      const m = moment(text)
      return m.isValid() ? m.format('DD-MM-YYYY') : text
    },
    handleTableChange(pagination, filters, sorter) {
      // TODO Filter
      // if (Object.keys(sorter).length > 0) {
      //   this.isorter.column = sorter.field
      //   this.isorter.order = sorter.order === 'ascend' ? 'asc' : 'desc'
      // }
      this.ipagination = pagination
      this.loadData()
    },
    handleAdd() {
      this.$refs.modalForm.add()
      // this.$refs.modalForm.title = 'Add new'
    },
    // Reset dictionary type search box content
    searchReset() {
      var that = this
      that.queryParam.appSsid = ''
      that.loadData(this.ipagination.current)
    },
    // modelCallback
    modalFormOk() {
      this.loadData()
    },
    handleChangeUpload(info) {
      if (info.file.status !== 'uploading') {
        console.log(info.file, info.fileList)
      }
      if (info.file.status === 'done') {
        this.$message.success(`${info.file.name} file uploaded successfully`)
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.name} file upload failed.`)
      }
    },
    downLoadData(arg2) {
      var params = this.getQueryParams(arg2) // Query conditions
      const file = {
        fileUrl:
          '/api/web/webpublic/statistics/appAllCountForDateExcel?startDate=' +
          params.startDate +
          '&endDate=' +
          params.endDate +
          '&productType=' +
          params.productType,
        fileName: 'appAllCountExcel.xls',
      }
      this.loading = true
      exportFile(file)
        .catch((e) => {
          this.$message.error(e.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>
<style lang="less" scoped>
@import '~@/assets/less/common.less';

.search-form {
  margin-bottom: 16px;
}

.table-page-search-wrapper {
  width: 100%;
}

.form-buttons {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-top: 24px; // Align with form elements
}

@media (max-width: 768px) {
  .form-buttons {
    padding-top: 16px;
  }
}
</style>
